import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import AuthShell, { Field, PrimaryBtn } from "./AuthShell";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success(`Bem-vindo, ${data.user.name.split(" ")[0]}!`);
      nav(data.user.role === "manager" ? "/gestao" : "/app");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="login-page" title="Entrar no KONDDO" subtitle="Acesse a comunidade do seu condomínio.">
      <form onSubmit={submit} className="space-y-4">
        <Field label="E-mail" type="email" data-testid="login-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@email.com" required />
        <Field label="Senha" type="password" data-testid="login-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
        <PrimaryBtn type="submit" loading={loading} data-testid="login-submit">Entrar</PrimaryBtn>
      </form>
      <div className="mt-6 text-center text-sm text-muted-foreground space-y-1">
        <p>Ainda não tem conta?</p>
        <div className="flex justify-center gap-4">
          <Link to="/cadastro/morador" className="text-primary font-medium hover:underline" data-testid="link-register-resident">Sou morador</Link>
          <Link to="/cadastro/sindico" className="text-primary font-medium hover:underline" data-testid="link-register-manager">Sou síndico</Link>
        </div>
      </div>
    </AuthShell>
  );
}
